var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem20C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -13.25,
    x2: 226.85,
    y1: 723.73,
    y2: 723.73,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 118.2,
    x2: 254.33,
    y1: 623.86,
    y2: 652.77,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7",
    offset: 0.694
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -13.25,
    x2: 155.2,
    y1: 611.46,
    y2: 611.46,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -9.85,
    x2: 138.72,
    y1: 611.08,
    y2: 611.08,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 201.88,
    x2: 274.25,
    y1: 582.12,
    y2: 582.12,
    gradientTransform: "matrix(.799 -.6014 0 -1.2516 116.1 1373)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8D8D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0.196
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8D8D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 415.25,
    x2: 525.45,
    y1: 603.41,
    y2: 626.82,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7",
    offset: 0.694
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 308.8,
    x2: 445.15,
    y1: 593.38,
    y2: 593.38,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 308.8,
    x2: 503.2,
    y1: 684.28,
    y2: 684.28,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 311.6,
    x2: 431.87,
    y1: 593.05,
    y2: 593.05,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 563.4,
    x2: 622.01,
    y1: 393.45,
    y2: 393.45,
    gradientTransform: "matrix(.7989 -.6014 0 -1.2517 116.1 1373.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8D8D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0.196
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8D8D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 620.45,
    x2: 779.55,
    y1: 657.38,
    y2: 657.38,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 707.56,
    x2: 797.76,
    y1: 591.21,
    y2: 610.37,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7",
    offset: 0.694
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 620.45,
    x2: 732.05,
    y1: 582.98,
    y2: 582.98,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 622.7,
    x2: 721.15,
    y1: 582.73,
    y2: 582.73,
    gradientTransform: "matrix(1 0 0 -1 116 1138.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 921.33,
    x2: 969.3,
    y1: 212.75,
    y2: 212.75,
    gradientTransform: "matrix(.7989 -.6014 0 -1.2517 116.1 1373.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8D8D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0.196
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF",
    offset: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3A3",
    offset: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8D8D",
    offset: 1
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M895.55 462.2v.05L848 499.15H736.45l47.5-36.9v-.05z",
    transform: "translate(130.63 -157.96) scale(.49251)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m848 499.15 47.55-36.9v111.8l-47.5 36.9v-111.8z",
    transform: "translate(130.63 -157.96) scale(.49251)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M848.05 611h-111.6V499.15h111.6v111.8z",
    transform: "translate(130.63 -157.96) scale(.49251)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m493.339 87.876 23.394-18.173M571.697 69.678V124.765l-23.394 18.174v.025M548.278 87.876l23.42-18.173M493.339 87.876h54.94M516.733 69.678h54.964M548.303 142.964H493.34V87.876m54.964 0v55.063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m740.15 503.3-.9 1c7.066 1.5 14.783 2.567 23.15 3.2.398 0 .833.033 1.3.1.267 0 .55.018.85.051.533 0 1.018.05 1.45.149h.45c.732.034 1.45.067 2.148.101 2.067.1 4.2.167 6.4.199.967 0 1.967.033 3 .101h.3c.4-.534.852-.8 1.352-.8s.948.282 1.35.85h2.55c3.733-.033 7.602-.117 11.602-.25.767-.067 1.517-.1 2.25-.1.133-.033.267-.051.398-.051.667-.032 1.333-.05 2-.05 22.602-1.3 38.067-2.466 46.4-3.5l-1.5-1zm-1.45-2.8h108v109.65h-108v-1.5zm107.5 105.75c-8.333-1.033-23.8-2.2-46.4-3.5l-2-.05-.398-.05h-2.25c-2.533-.135-6.4-.25-11.602-.352H781c-.4.567-.85.852-1.35.852-.435 0-.885-.269-1.352-.802l-9.7.302c-.5 0-1.217.032-2.148.1H766l-3.6.35c-8.233.602-15.95 1.65-23.15 3.15l.9 1H844.7z",
    fill: "url(#f)",
    transform: "translate(130.63 -157.96) scale(.49251)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M495.161 89.92h51.492l.739.493c-4.104.509-11.722 1.083-22.853 1.724-.328 0-.656.008-.985.024a.804.804 0 0 0-.196.025c-.36 0-.73.016-1.108.05-1.97.065-3.874.106-5.714.123h-1.256c-.197-.28-.418-.419-.665-.419s-.467.132-.665.394h-.148a22.847 22.847 0 0 0-1.478-.05 94.651 94.651 0 0 1-3.152-.098l-1.058-.05h-.221a3.186 3.186 0 0 0-.714-.073 3.844 3.844 0 0 0-.42-.025 4.598 4.598 0 0 0-.64-.05c-4.12-.31-7.92-.836-11.401-1.575z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m547.392 140.624-.739.493h-51.492l-.443-.493c3.546-.739 7.347-1.256 11.402-1.551l1.773-.173h.221c.46-.032.812-.049 1.058-.049l4.778-.149c.23.263.451.395.665.395.247 0 .467-.139.665-.42h1.256c2.561.051 4.466.108 5.714.174h1.108l.196.025.985.024c11.131.64 18.749 1.215 22.853 1.724z",
    fill: "#999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m852.75 500.2-.4 1.25c2.769-.567 5.783-1.75 9.052-3.55.133-.101.3-.218.5-.351.1-.033.217-.083.35-.149.167-.167.35-.268.55-.301a.747.747 0 0 0 .2-.149c.233-.167.517-.317.85-.45l2.45-1.7c.367-.267.75-.533 1.15-.8a.381.381 0 0 1 .148-.05c.135-.667.302-1.067.5-1.2.2-.167.385-.017.552.45.3-.268.633-.534 1-.8a529.42 529.42 0 0 0 4.5-3.601c.3-.267.6-.517.898-.75a.803.803 0 0 1 .15-.2c.267-.267.517-.482.75-.649 8.8-7.9 14.833-13.601 18.1-17.101l-.6-.6zm-.6-2.3 42.05-31.7v109.65l-42.05 31.65V606zm22 85.55c-.968.6-2.468 1.616-4.5 3.05l-1 .75c-.167.667-.352 1.083-.552 1.25-.166.1-.333-.033-.5-.4l-3.75 3.102c-.231.133-.517.383-.85.75l-.2.148-1.398 1.352a90.006 90.006 0 0 0-9.052 10l.4.7 40.7-30.65.6-1.4c-3.267 1.367-9.3 4.733-18.1 10.102z",
    fill: "url(#e)",
    transform: "translate(130.63 -157.96) scale(.49251)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m550.618 88.394 20.045-15.12.296.295c-1.61 1.724-4.58 4.531-8.915 8.422a3.06 3.06 0 0 0-.37.32.378.378 0 0 0-.073.099 8.21 8.21 0 0 0-.442.369c-.772.624-1.51 1.215-2.217 1.773-.18.132-.344.262-.492.394-.082-.23-.174-.303-.272-.221-.098.065-.18.262-.246.59a.188.188 0 0 0-.073.025c-.197.132-.386.263-.567.394l-1.206.838c-.164.065-.303.14-.419.221a.379.379 0 0 1-.098.074.495.495 0 0 0-.271.148 1.354 1.354 0 0 1-.173.073 4.94 4.94 0 0 0-.246.173c-1.61.887-3.094 1.469-4.458 1.749z",
    fill: "#ccc"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m561.158 129.395.886-.616c4.334-2.643 7.306-4.3 8.915-4.975l-.296.69-20.045 15.095-.197-.345a44.329 44.329 0 0 1 4.458-4.925l.689-.666.098-.073c.164-.18.304-.304.419-.37l1.847-1.527c.082.18.164.246.246.197.098-.082.19-.287.272-.615l.492-.37c1.001-.704 1.74-1.205 2.216-1.5z",
    fill: "#999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Heebo-Bold",
    fontSize: 35
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(505 110) scale(.49251)"
  }, "2kg"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(500 130) scale(.49251)"
  }, "Steel"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m561.1 476.35 58.1-45.05v136.55l-58.05 45.1v-136.6z",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M561.15 613H424.8V476.35H561.15v136.6z",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M619.2 431.2v.1l-58.1 45.05H424.8l58.05-45.05v-.1z",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.002 143.924 28.59-22.213V54.459m0-.05v.05m-28.59 89.464v.025M435.592 54.46l-28.615 22.187M407.002 76.647v67.277m0 .025h-67.154V76.647M339.848 76.647l28.59-22.187M339.848 76.647h67.13M368.438 54.41h67.154",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558.9 482.65-1.802-1.2h-127.75l-1.1 1.2c8.633 1.833 18.066 3.133 28.3 3.899.467 0 1 .05 1.601.15.3 0 .633.017 1 .05.667 0 1.267.067 1.8.2h.55c.9.033 1.767.065 2.6.1 2.533.133 5.15.217 7.851.25 1.167 0 2.383.034 3.649.101h.351c.5-.634 1.05-.95 1.649-.95.634 0 1.184.35 1.65 1.05h3.15c4.532-.067 9.25-.183 14.149-.35a39.062 39.062 0 0 1 2.75-.101 2.57 2.57 0 0 1 .5-.05c.8-.033 1.617-.05 2.45-.05 27.6-1.599 46.483-3.032 56.65-4.299zm0 124.55c-10.167-1.268-29.052-2.685-56.65-4.25l-2.45-.05-.5-.102h-2.75c-3.1-.167-7.815-.3-14.149-.398h-3.15c-.467.666-1.017 1-1.65 1-.533 0-1.083-.317-1.649-.95l-11.852.35c-.6 0-1.467.05-2.6.15h-.55l-4.4.398c-10.065.733-19.5 2.019-28.3 3.852l1.1 1.25H557.1zm.65-129.2v134H427.6V478z",
    fill: "url(#a)",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.894 79.75c-5.008.624-14.309 1.33-27.9 2.118-.411 0-.813.008-1.208.024-.082 0-.164.009-.246.025-.443 0-.894.017-1.354.05-2.413.082-4.737.139-6.969.172h-1.551c-.23-.345-.501-.517-.813-.517-.295 0-.566.155-.812.468h-.173a34.6 34.6 0 0 0-1.797-.05 96.244 96.244 0 0 1-3.867-.123l-1.28-.05h-.271a3.674 3.674 0 0 0-.887-.098 5.546 5.546 0 0 0-.492-.024 4.803 4.803 0 0 0-.789-.074c-5.039-.378-9.686-1.017-13.938-1.92l.542-.592h62.918z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.894 141.092-.888.616h-62.918l-.542-.616c4.335-.903 8.98-1.535 13.938-1.897l2.167-.196h.271c.558-.05.985-.074 1.28-.074l5.838-.172c.278.311.55.468.812.468.312 0 .583-.165.812-.493h1.552c3.119.05 5.442.114 6.968.196h1.355l.246.05 1.207.025c13.593.772 22.894 1.47 27.9 2.093z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.35 469.1c.367-.333.769-.667 1.2-1a220.37 220.37 0 0 0 5.5-4.399c.367-.3.733-.601 1.102-.9.065-.065.133-.149.198-.25.334-.333.635-.6.9-.8 10.767-9.633 18.15-16.6 22.15-20.9l-.75-.699-49.75 37.5-.45 1.5c3.366-.667 7.05-2.101 11.05-4.301.167-.133.367-.283.6-.449.135-.033.283-.101.45-.2.2-.2.417-.317.65-.351.1-.033.183-.1.25-.199.3-.2.648-.384 1.05-.551.934-.633 1.934-1.316 3-2.05.434-.333.9-.667 1.4-1a.376.376 0 0 1 .148-.05c.167-.8.384-1.283.65-1.45.236-.201.452-.018.652.549zm-20.15 5.75 51.35-38.75v133.95l-51.35 38.7v-1.85zm26.85 104.5c-1.167.733-3 1.983-5.5 3.75l-1.2.9c-.198.8-.416 1.316-.648 1.55-.233.102-.45-.065-.65-.5l-4.55 3.75c-.3.167-.65.483-1.05.95l-.25.15-1.7 1.648a114.918 114.918 0 0 0-11.05 12.25l.45.852 49.75-37.45.75-1.7c-4 1.667-11.385 5.783-22.15 12.35z",
    fill: "url(#o)",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.413 73.076c-.097-.278-.205-.369-.319-.27-.132.082-.238.32-.32.714a.185.185 0 0 0-.073.024c-.246.164-.477.329-.69.493-.524.36-1.017.698-1.477 1.01a3.05 3.05 0 0 0-.517.27.234.234 0 0 1-.123.099.562.562 0 0 0-.32.173.824.824 0 0 1-.222.098 8.247 8.247 0 0 0-.296.221c-1.97 1.084-3.784 1.79-5.442 2.119l.222-.74 24.502-18.468.37.344c-1.97 2.118-5.608 5.55-10.91 10.293a4.31 4.31 0 0 0-.443.395.746.746 0 0 1-.097.123c-.181.147-.361.296-.543.443-.935.77-1.838 1.494-2.709 2.166a9.311 9.311 0 0 0-.593.493z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.713 127.376 1.084-.74c5.302-3.232 8.939-5.26 10.909-6.082l-.37.838-24.502 18.444-.222-.42a56.492 56.492 0 0 1 5.443-6.033l.837-.811.123-.074c.196-.23.37-.386.517-.468l2.241-1.847c.098.214.205.296.32.246.114-.114.222-.37.32-.763l.59-.443c1.233-.87 2.135-1.486 2.71-1.847z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Heebo-Bold",
    fontSize: 35
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(360 105) scale(.49251)"
  }, "5kg"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(355 125) scale(.49251)"
  }, "Steel")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M342.85 386.45v.05l-71.75 55.7H102.75l71.7-55.7v-.05z",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m271.1 442.2 71.75-55.7v168.75l-71.65 55.7V442.2z",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M271.2 611H102.75V442.2H271.2v168.75z",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m181.235 59.828 35.313-27.433M299.487 32.37V115.506L264.2 142.94v.025M264.15 59.828l35.337-27.433M181.235 59.828h82.914M216.548 32.37h82.94M264.199 142.964h-82.964V59.828m82.964 0v83.111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5 455.85h.45c.6-.8 1.267-1.199 2-1.199.767 0 1.45.434 2.05 1.3h3.85c5.633-.067 11.467-.2 17.5-.4 1.167-.1 2.3-.149 3.4-.149.2-.033.4-.051.6-.051 1-.066 2.017-.1 3.05-.1 34.1-1.967 57.434-3.717 70-5.25l-2.25-1.55h-157.8L107 450c10.667 2.267 22.317 3.867 34.95 4.8.6 0 1.25.05 1.95.15.4 0 .833.033 1.3.1.8 0 1.517.067 2.15.2h.7c1.1.066 2.184.117 3.25.15 3.1.167 6.317.267 9.65.3 1.467 0 2.983.05 4.55.15zm-59.35-11.6h163V609.7h-163v-2.25zm85.2 154.15c-3.8-.2-9.633-.385-17.5-.552H170c-.6.867-1.283 1.302-2.05 1.302-.633 0-1.3-.4-2-1.2l-14.65.45c-.767 0-1.85.05-3.25.148h-.7l-5.4.55c-12.434.9-24.083 2.483-34.95 4.75l1.35 1.5h157.8l2.25-1.5c-12.566-1.565-35.9-3.333-70-5.3z",
    fill: "url(#k)",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.14 66.55a35.193 35.193 0 0 0-2.24-.073 109.93 109.93 0 0 1-4.753-.147 53.64 53.64 0 0 1-1.6-.074h-.346a5.174 5.174 0 0 0-1.059-.099 4.675 4.675 0 0 0-.64-.05 6.747 6.747 0 0 0-.96-.073c-6.222-.46-11.96-1.247-17.213-2.364l.664-.763h77.719l1.108.763c-6.19.755-17.681 1.617-34.476 2.586-.509 0-1.01.016-1.502.049-.099 0-.197.009-.296.025-.541 0-1.1.025-1.674.073-2.972.099-5.845.164-8.62.197h-1.895c-.296-.427-.632-.64-1.01-.64-.361 0-.69.197-.985.59h-.222z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.872 136.758 3.472.073c16.795.969 28.287 1.838 34.476 2.61l-1.108.739h-77.719l-.664-.739c5.352-1.116 11.09-1.896 17.213-2.34l2.66-.27h.344a23.92 23.92 0 0 1 1.6-.073l7.216-.222c.345.394.673.591.985.591.378 0 .714-.214 1.01-.64h1.896c3.874.082 6.747.172 8.619.271z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.6 398.35-.9-.899-61.4 46.35-.6 1.9c4.167-.867 8.716-2.667 13.65-5.4l.75-.5c.133-.065.3-.149.5-.25a1.94 1.94 0 0 1 .85-.45c.1-.033.2-.1.3-.199.367-.268.8-.5 1.3-.7 1.134-.8 2.367-1.65 3.7-2.55.533-.4 1.1-.801 1.7-1.2a.485.485 0 0 1 .25-.101c.2-1 .45-1.6.75-1.8.3-.267.583-.033.85.7.434-.4.934-.816 1.5-1.25 2.167-1.7 4.434-3.5 6.8-5.4.433-.399.883-.783 1.35-1.149.033-.101.1-.2.2-.3.4-.4.784-.733 1.15-1 13.266-11.902 22.367-20.502 27.3-25.802zm-63.2 41.95 63.45-47.8v165.45L277.4 605.7v-2.25zm63.2 112c-4.934 2.066-14.034 7.15-27.3 15.25l-2.7 1.852c-1.467.933-3.733 2.482-6.8 4.648l-1.5 1.102c-.267 1-.55 1.633-.85 1.898-.267.134-.517-.065-.75-.6l-5.65 4.648c-.366.2-.8.584-1.3 1.15l-2.4 2.25c-4.833 4.6-9.383 9.633-13.65 15.1l.6 1.052 61.4-46.25z",
    fill: "url(#j)",
    transform: "translate(130.63 -157.96) scale(.49251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.379 38.231c-2.43 2.611-6.912 6.846-13.446 12.708-.18.131-.369.295-.566.492a.382.382 0 0 0-.099.148c-.23.18-.451.37-.664.566a383.654 383.654 0 0 1-3.35 2.66c-.278.213-.524.418-.738.615-.132-.361-.271-.476-.419-.345-.148.099-.27.394-.37.887a.235.235 0 0 0-.122.05c-.296.196-.575.393-.838.59-.656.443-1.263.862-1.822 1.256-.246.099-.46.214-.64.345a.378.378 0 0 1-.148.098.945.945 0 0 0-.419.222l-.246.123-.37.246c-2.43 1.346-4.67 2.233-6.722 2.66l.296-.936 30.24-22.828z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.379 114.053-.443 1.036-30.24 22.778-.296-.518a67.97 67.97 0 0 1 6.723-7.437l1.182-1.108c.246-.279.46-.468.64-.566l2.783-2.29c.115.263.238.36.37.296.147-.132.286-.442.418-.935l.739-.543c1.51-1.066 2.626-1.83 3.349-2.289l1.33-.912c6.533-3.99 11.015-6.494 13.445-7.512z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Heebo-Bold",
    fontSize: 35
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(200 95) scale(.49251)"
  }, "10kg"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(200 120) scale(.49251)"
  }, "Steel")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M550.42 231.96c0 5.5-1.936 10.187-5.81 14.061-3.875 3.858-8.562 5.787-14.062 5.787s-10.187-1.929-14.061-5.787c-3.858-3.874-5.787-8.561-5.787-14.06s1.93-10.188 5.787-14.062c3.874-3.875 8.561-5.813 14.061-5.813s10.187 1.938 14.061 5.813c3.875 3.875 5.812 8.561 5.812 14.061z",
    fill: "#7493b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.455 226.05h.025c1.035.016 1.846.296 2.438.837.59.525.886 1.24.886 2.143 0 .328-.065.615-.196.862-.115.246-.296.46-.543.64-.18.164-.401.345-.665.543a12.8 12.8 0 0 1-.912.615v.05c.707.098 1.298.312 1.774.64.493.328.862.722 1.108 1.182.247.476.37.976.37 1.502-.016.755-.181 1.42-.493 1.995a5.152 5.152 0 0 1-1.231 1.502 7.412 7.412 0 0 1-1.6 1.035 8.811 8.811 0 0 1-1.552.616c-.476.131-.846.196-1.108.196a3.666 3.666 0 0 1-1.304-.271c-.395-.148-.698-.32-.913-.517a.987.987 0 0 1-.295-.419c-.066-.149-.066-.32 0-.518.05-.132.123-.262.222-.394.097-.148.213-.263.343-.345a.538.538 0 0 1 .345-.148.56.56 0 0 1 .32.174c.18.164.402.336.665.517.263.196.55.36.862.492.312.132.648.205 1.01.222.378 0 .73-.115 1.059-.345.328-.214.59-.55.788-1.01.197-.46.303-1.042.32-1.749-.017-.688-.148-1.256-.394-1.698-.263-.427-.584-.739-.96-.936a2.576 2.576 0 0 0-1.158-.295c-.263 0-.51.024-.739.073-.246.05-.468.107-.666.173l-.172-.69c1.017-.377 1.814-.82 2.389-1.33.574-.508.862-1.124.862-1.846-.017-.64-.19-1.125-.518-1.453-.344-.328-.78-.493-1.305-.493-.492.017-.935.181-1.329.493a5.476 5.476 0 0 0-.985 1.059l-.518-.468 1.01-1.404c.296-.344.69-.632 1.182-.862a3.381 3.381 0 0 1 1.578-.37z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.89 231.936c0 5.499-1.937 10.186-5.811 14.06-3.875 3.875-8.554 5.812-14.037 5.812-5.5 0-10.186-1.937-14.061-5.811-3.875-3.875-5.812-8.562-5.812-14.061 0-5.5 1.938-10.188 5.812-14.063 3.875-3.857 8.561-5.787 14.061-5.787 5.483 0 10.162 1.93 14.037 5.787 3.874 3.876 5.811 8.563 5.811 14.063z",
    fill: "#7493b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.068 227.675v-.69c.804-.097 1.6-.237 2.388-.418a53.945 53.945 0 0 0 2.414-.665v8.101c0 .378.024.682.074.912.049.214.156.378.32.493.164.081.427.147.788.196l1.33.123v.739h-7.536v-.74l1.38-.147c.508-.032.828-.164.96-.394.147-.23.213-.624.197-1.182v-4.875c.016-.525-.033-.886-.148-1.083-.115-.18-.386-.279-.813-.296z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.643 231.936c0 5.499-1.937 10.186-5.811 14.06-3.874 3.875-8.562 5.812-14.062 5.812-5.483 0-10.161-1.937-14.036-5.811-3.875-3.875-5.812-8.562-5.812-14.061 0-5.5 1.938-10.188 5.812-14.063 3.875-3.873 8.553-5.811 14.036-5.811 5.5 0 10.188 1.938 14.062 5.811 3.874 3.876 5.811 8.563 5.811 14.063z",
    fill: "#7493b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.003 227.75c-.329.179-.624.418-.887.712-.246.28-.476.56-.69.838l-.565-.468 1.305-1.872c.394-.41.846-.73 1.354-.96.492-.23 1.059-.344 1.7-.344.738 0 1.378.148 1.92.442.558.297.985.698 1.28 1.207.297.492.452 1.059.468 1.7 0 .688-.205 1.321-.615 1.895-.41.559-1.068 1.15-1.97 1.774a52.77 52.77 0 0 1-.887.689c-.328.262-.707.558-1.133.886v.05h3.325c.394.017.706-.008.935-.073.23-.05.427-.164.59-.345.165-.164.337-.435.518-.812l.666.173-.74 2.98h-8.741v-.567c.492-.329 1.05-.707 1.674-1.133.607-.427 1.19-.895 1.748-1.404a7.55 7.55 0 0 0 1.404-1.626c.36-.59.55-1.206.566-1.847a2.61 2.61 0 0 0-.22-1.083c-.15-.328-.37-.6-.666-.812-.312-.197-.714-.304-1.207-.32-.41.015-.787.122-1.132.32z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem20C);
export default __webpack_public_path__ + "static/media/item20c.8b343e20713ee1ce29971d22bd12d37b.svg";
export { ForwardRef as ReactComponent };